module.exports = __webpack_public_path__ + "static/12-raudur-bb9e27ddfff89b1e69c80a44dbee6edd.jpg";